/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../types';

import * as TypescriptOperationsGenerated from "graphql/typescript-operations.generated"
import * as Operations from 'graphql/document-nodes.generated';
import { NextPage } from 'next';
import { NextRouter, useRouter } from 'next/router'
import { QueryHookOptions, useQuery } from '@apollo/client';
import * as Apollo from '@apollo/client';
import type React from 'react';
import { getApolloClient , ApolloClientContext} from 'withApollo';
export async function getServerPageGetSuggestionCard
    (options: Omit<Apollo.QueryOptions<TypescriptOperationsGenerated.GetSuggestionCardQueryVariables>, 'query'>, ctx: ApolloClientContext ){
        const apolloClient = getApolloClient(ctx);
        
        const data = await apolloClient.query<TypescriptOperationsGenerated.GetSuggestionCardQuery>({ ...options, query: Operations.GetSuggestionCardDocument });
        
        const apolloState = apolloClient.cache.extract();

        return {
            props: {
                apolloState: apolloState,
                data: data?.data,
                error: data?.error ?? data?.errors ?? null,
            },
        };
      }
export const useGetSuggestionCard = (
  optionsFunc?: (router: NextRouter)=> QueryHookOptions<TypescriptOperationsGenerated.GetSuggestionCardQuery, TypescriptOperationsGenerated.GetSuggestionCardQueryVariables>) => {
  const router = useRouter();
  const options = optionsFunc ? optionsFunc(router) : {};
  return useQuery(Operations.GetSuggestionCardDocument, options);
};
export type PageGetSuggestionCardComp = React.FC<{data?: TypescriptOperationsGenerated.GetSuggestionCardQuery, error?: Apollo.ApolloError}>;
export const withPageGetSuggestionCard = (optionsFunc?: (router: NextRouter)=> QueryHookOptions<TypescriptOperationsGenerated.GetSuggestionCardQuery, TypescriptOperationsGenerated.GetSuggestionCardQueryVariables>) => (WrappedComponent:PageGetSuggestionCardComp) : NextPage  => (props) => {
                const router = useRouter()
                const options = optionsFunc ? optionsFunc(router) : {};
                const {data, error } = useQuery(Operations.GetSuggestionCardDocument, options)    
                return <WrappedComponent {...props} data={data} error={error} /> ;
                   
            }; 
export const ssrGetSuggestionCard = {
      getServerPage: getServerPageGetSuggestionCard,
      withPage: withPageGetSuggestionCard,
      usePage: useGetSuggestionCard,
    }